import React from 'react';
import './rooms.css';
import $ from 'jquery';
import twosingle from "../../assets/two-single.png";
import onedouble from "../../assets/one-double.png";
import twoone from "../../assets/two-one.png";
import threesingle from "../../assets/three-single.png";
import twodouble from "../../assets/two-double.png";
import fivesingle from "../../assets/five-single.png";
import presidential from "../../assets/presidential.png";

const Rooms = () => {

    $(document).ready(function(){
        $("#allrooms").click(function(){
            $("#filterrooms h2").css({"background-color": "var(--orange)", "color": "black"});
            $(this).css({"background-color": "black", "color": "var(--orange)"}); 
            $("#rooms h1").show();
            $(".room").show();
        });

        $("#onetwoguests").click(function(){
            $("#filterrooms h2").css({"background-color": "var(--orange)", "color": "black"});
            $(this).css({"background-color": "black", "color": "var(--orange)"});
            $("#rooms h1").hide();
            $("#onetwotext").show();
            $(".room").hide();
            $(".onetwo").show();
        });

        $("#threeguests").click(function(){
            $("#filterrooms h2").css({"background-color": "var(--orange)", "color": "black"});
            $(this).css({"background-color": "black", "color": "var(--orange)"});
            $("#rooms h1").hide();
            $("#threetext").show();
            $(".room").hide();
            $(".threeperson").show();
        });

        $("#fourguests").click(function(){
            $("#filterrooms h2").css({"background-color": "var(--orange)", "color": "black"});
            $(this).css({"background-color": "black", "color": "var(--orange)"});
            $("#rooms h1").hide();
            $("#fourfivetext").show();
            $(".room").hide();
            $(".fourfive").show();
        });

        $("#presidential").click(function(){
            $("#filterrooms h2").css({"background-color": "var(--orange)", "color": "black"});
            $(this).css({"background-color": "black", "color": "var(--orange)"});
            $("#rooms h1").hide();
            $("#presidentialtext").show();
            $(".room").hide();
            $(".presidentialsuite").show();
        });
    });

    return (
        <div>
            <div id='roomsbanner' className="pagebanner">
                <h1>Rooms</h1>
            </div>

            <h1 id='exprooms'>Explore, choose, and book rooms</h1>

            <div id='filterrooms'>
                <h2 id='allrooms'>All rooms</h2>
                <h2 id='onetwoguests'>1/2 Guests</h2>
                <h2 id='threeguests'>3 Guests</h2>
                <h2 id='fourguests'>4/5 Guests</h2>
                <h2 id='presidential'>Presidential</h2>
            </div>

            <div id="rooms">
                <h1 id='onetwotext'>One/Two Guests</h1>
                <div className="room onetwo">
                    <img src={onedouble} alt="" />
                    <div className='roomtext'>
                        <h2>Double Luxury Suite</h2>
                        <h3>Includes one double bed for accomodation of 1-2 guests</h3>
                    </div>
                    <h2 className='priceroom'>$60/night</h2>
                    <div>
                        <a href='https://booking.com' target='_blank' rel="noreferrer"><button>Book now</button></a>
                    </div>
                </div>

                <div className="room onetwo">
                    <img src={twosingle} alt="" />
                    <div className='roomtext'>
                        <h2>Twin Luxury Suite</h2>
                        <h3>Includes two single beds for accomodation of 2 guests</h3>
                    </div>
                    <h2 className='priceroom'>$65/night</h2>
                    <div>
                        <a href='https://booking.com' target='_blank' rel="noreferrer"><button>Book now</button></a>
                    </div>
                </div>

                <h1 id='threetext'>Three Guests</h1>

                <div className="room threeperson">
                    <img src={twoone} alt="" />
                    <div className='roomtext'>
                        <h2>Triple Luxury Suite</h2>
                        <h3>Includes a double bed & a couch for accomodation of 2-3 guests</h3>
                    </div>
                    <h2 className='priceroom'>$70/night</h2>
                    <div>
                        <a href='https://booking.com' target='_blank' rel="noreferrer"><button>Book now</button></a>
                    </div>
                </div>

                <div className="room threeperson">
                    <img src={threesingle} alt="" />
                    <div className='roomtext'>
                        <h2>Triple Bed Suite</h2>
                        <h3>Includes three single beds for accomodation of 3 guests</h3>
                    </div>
                    <h2 className='priceroom'>$75/night</h2>
                    <div>
                        <a href='https://booking.com' target='_blank' rel="noreferrer"><button>Book now</button></a>
                    </div>
                </div>

                <h1 id='fourfivetext'>Four/Five Guests</h1>

                <div className="room fourfive">
                    <img src={twodouble} alt="" />
                    <div className='roomtext'>
                        <h2>2x Double Suite</h2>
                        <h3>Includes two double beds for accomodation of 2-4 guests</h3>
                    </div>
                    <h2 className='priceroom'>$80/night</h2>
                    <div>
                        <a href='https://booking.com' target='_blank' rel="noreferrer"><button>Book now</button></a>
                    </div>
                </div>

                <div className="room fourfive">
                    <img src={fivesingle} alt="" />
                    <div className='roomtext'>
                        <h2>5x Single Beds</h2>
                        <h3>Includes five single beds for accomodation of 4-5 guests</h3>
                    </div>
                    <h2 className='priceroom'>$90/night</h2>
                    <div>
                        <a href='https://booking.com' target='_blank' rel="noreferrer"><button>Book now</button></a>
                    </div>
                </div>

                <h1 id='presidentialtext'>Presidential Room</h1>

                <div className="room presidentialsuite">
                    <img src={presidential} alt="" />
                    <div className='roomtext'>
                        <h2>Presidential Suite</h2>
                        <h3>Our most luxurious suite includes a double bed for 1/2 Guests</h3>
                    </div>
                    <h2 className='priceroom'>$150/night</h2>
                    <div>
                        <a href='https://booking.com' target='_blank' rel="noreferrer"><button>Book now</button></a>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Rooms;